module.exports = __webpack_public_path__ + "img/12.de2a39a7.png";